import { t } from "i18next";
import i18n from "../../../i18n";
import { navigateTo } from "../../../router/appRouter";

interface customProps {
  title?: string;
  subTitle?: string;
  cancelModal?(): void;
  confirmModal?(): void;
}

const Success = (props: customProps) => {
  const backtohome = () => {
    navigateTo(`/${i18n.language}/`);
  };

  return (
    <>
      <div
        className={`z-50 fixed inset-0 flex items-center justify-center bg-black bg-opacity-50`}
      >
        <div
          className={`bg-white p-8 rounded-xl relative shadow-lg m-7 w-full md:max-w-[654px]`}
        >
          <div className="modal-content w-full mx-auto">
            <div className="flex flex-col items-center text-center justify-center">
              <svg
                width="62"
                height="62"
                viewBox="0 0 62 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M59.2148 30.9878C59.2148 30.9636 59.2148 30.9272 59.2148 30.903C59.2148 30.7093 59.2148 30.5155 59.2027 30.3339C59.2027 30.2249 59.1906 30.1159 59.1906 29.9948C59.1906 29.8858 59.1785 29.7769 59.1785 29.6679C59.1664 29.5347 59.1664 29.4015 59.1543 29.2683C59.1543 29.1835 59.1422 29.0987 59.1422 29.014C59.1301 28.8687 59.118 28.7233 59.1059 28.578C59.1059 28.5175 59.0938 28.4448 59.0938 28.3843C59.0816 28.2269 59.0574 28.0694 59.0453 27.8999C59.0453 27.8636 59.0332 27.8151 59.0332 27.7788C57.4348 13.7077 45.4949 2.77295 31 2.77295C16.5051 2.77295 4.56523 13.7077 2.9668 27.7909C2.9668 27.8272 2.95469 27.8757 2.95469 27.912C2.94258 28.0694 2.91836 28.2269 2.90625 28.3964C2.89414 28.4569 2.89414 28.5296 2.89414 28.5901C2.88203 28.7355 2.86992 28.8808 2.85781 29.0261C2.85781 29.1108 2.8457 29.1956 2.8457 29.2804C2.83359 29.4136 2.83359 29.5468 2.82148 29.68C2.82148 29.789 2.80938 29.898 2.80938 30.0069C2.80938 30.1159 2.79727 30.2249 2.79727 30.346C2.79727 30.5397 2.78516 30.7335 2.78516 30.9151C2.78516 30.9394 2.78516 30.9757 2.78516 30.9999C2.78516 30.9999 2.78516 30.9999 2.78516 31.012C2.78516 31.0241 2.78516 31.012 2.78516 31.0241C2.78516 31.0483 2.78516 31.0847 2.78516 31.1089C2.78516 31.3026 2.78516 31.4964 2.79727 31.678C2.79727 31.787 2.80938 31.896 2.80938 32.0171C2.80938 32.1261 2.82148 32.2351 2.82148 32.344C2.83359 32.4772 2.83359 32.6105 2.8457 32.7437C2.8457 32.8284 2.85781 32.9132 2.85781 32.998C2.86992 33.1433 2.88203 33.2886 2.89414 33.4339C2.89414 33.4944 2.90625 33.5671 2.90625 33.6276C2.91836 33.7851 2.94258 33.9425 2.95469 34.112C2.95469 34.1483 2.9668 34.1968 2.9668 34.2331C4.56523 48.2921 16.5051 59.2269 31 59.2269C45.4949 59.2269 57.4348 48.2921 59.0332 34.221C59.0332 34.1847 59.0453 34.1362 59.0453 34.0999C59.0574 33.9425 59.0816 33.7851 59.0938 33.6155C59.1059 33.555 59.1059 33.4823 59.1059 33.4218C59.118 33.2765 59.1301 33.1312 59.1422 32.9858C59.1422 32.9011 59.1543 32.8163 59.1543 32.7315C59.1664 32.5983 59.1664 32.4651 59.1785 32.3319C59.1785 32.223 59.1906 32.114 59.1906 32.005C59.1906 31.896 59.2027 31.787 59.2027 31.6659C59.2027 31.4722 59.2148 31.2784 59.2148 31.0968C59.2148 31.0726 59.2148 31.0362 59.2148 31.012C59.2148 30.9999 59.2148 30.9999 59.2148 30.9878C59.2148 30.9999 59.2148 30.9999 59.2148 30.9878Z"
                  fill="#27AE60"
                />
                <path
                  d="M25.8633 41.6802L44.766 22.7896"
                  stroke="white"
                  stroke-width="3.63281"
                  stroke-miterlimit="10"
                />
                <path
                  d="M28.309 41.8012L18.7305 32.2227"
                  stroke="white"
                  stroke-width="3.63281"
                  stroke-miterlimit="10"
                />
              </svg>
              <p className="font-medium text-xl text-black mt-4">
                {t("Thank you", i18n.language)}
              </p>
              <p className="mt-[20px] text-muted font-medium text-sm mb-0">
                {t(
                  "We’ve received your report and will address it promptly. Our support team will contact you if more information is needed.",
                  i18n.language
                )}
              </p>
              <div className="masterBtn mt-[40px]">
                <button
                  className="h-12 text-sm sm:w-40 w-28 disabled:bg-[#C6C8C9] bg-secondary cursor-pointer disabled:cursor-not-allowed text-white rounded-md"
                  onClick={() => backtohome()}
                >
                  {t("Go Home", i18n.language)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Success;
